module.exports = __webpack_public_path__ + "ca45a5db1038cc253936e5333cd17486.MP3";